<template>
<!-- 我的 -->
  <div class="myList">
    <div class="userList-big" v-loading='loads.show' v-if="memberInfo">
      <div class="userList-top">
        <el-row>
          <el-col :span="13">
            <div class="left">
              <el-row>
                <el-col :span="5" :style="memberInfo.gradeName?'':'display:none'">
                  <img :src="require('../../assets/img/会员图标/青铜会员.png')" alt="" v-if="memberInfo.gradeName=='青铜会员'">
                  <img :src="require('../../assets/img/会员图标/白银会员.png')" alt="" v-else-if="memberInfo.gradeName=='白银会员'">
                  <img :src="require('../../assets/img/会员图标/黄金会员.png')" alt="" v-else-if="memberInfo.gradeName=='黄金会员'">
                  <img :src="require('../../assets/img/会员图标/铂金会员.png')" alt="" v-else-if="memberInfo.gradeName=='铂金会员'">
                  <img :src="require('../../assets/img/会员图标/钻石会员.png')" alt="" v-else-if="memberInfo.gradeName=='钻石会员'">
                </el-col>
                <el-col :span="15">
                  <h2>{{memberInfo.companyName}}</h2>
                  <p>
                    <span v-if="memberInfo.companyGrade == 5">
                        已是最高会员等级，请持续下单保持。
                    </span>
                    <span v-else-if="memberInfo.companyGrade < 5 && memberInfo.companyGrade > 0">
                        再下单大于等于
                        <span>{{ requiredAmount }}美元</span>
                        升级到L{{ memberInfo.companyGrade + 1 }}{{ memberList[memberInfo.companyGrade] ? memberList[memberInfo.companyGrade].gradeName : '' }}
                    </span>
                    <span v-else>
                        再下单大于等于0美元升级到L1青铜会员
                    </span>
                  </p>
                  <ul>
                    <li @click="drawer1 = true">
                      <div>优惠券</div>
                      <p>{{coupon || 0}}</p>
                    </li>
                    <li @click="balanceDrawer = true">
                      <div>余额</div>
                      <p>{{ $filters.formatMoney(nowMoney || 0) }}</p>
                    </li>
                    <li style="margin-right: 0">
                      <div @click="copyNumber">入仓号 <ab-svg name="my-fuzhi"></ab-svg></div>
                      <p style="color: #f37041">{{number || 0}}</p>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div></el-col
          >
          <el-col :span="11">
            <div class="right">
              <div class="title" @click="upgradeDrawer = true">升级攻略>></div>
              <div class="aaa" v-if="memberList.length">
                <div id="main"></div>
                <div class="bronze" > {{memberList[0].gradeName.slice(0,2)}} <i></i> >0</div>
                <div class="silver"> {{memberList[1].gradeName.slice(0,2)}} <i></i> >{{memberList[1].standardValue}}</div>
                <div class="gold">{{memberList[2].gradeName.slice(0,2)}} <i></i> >{{memberList[2].standardValue}}</div>
                <div class="Platinum">{{memberList[3].gradeName.slice(0,2)}} <i></i> >{{memberList[3].standardValue}}</div>
                <div class="diamond" >{{memberList[4].gradeName.slice(0,2)}} <i></i> >{{memberList[4].standardValue}}</div>
                <div class="wordValue" @click="drawer3 = true" >
                    <p>当前成长值</p>
                    <div>{{ memberInfo.growthValue || 0 }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="userList-btm">
        <ul>
          <li>
            <i><ab-svg name="my-jifei"></ab-svg></i>
            <div>
                <div>积分加速系数</div>
                <p  v-if="memberBenefits.integralMagnigication == 1"><ab-svg name="my-heng"></ab-svg></p>
                <p style="font-family: DIN_Condensed_Bold" v-else>{{memberBenefits.integralMagnigication || 1}}</p>
            </div>
          </li>
          <li>
            <i><ab-svg name="my-quan"></ab-svg></i>
            <div>
                <div>每月赠券(元)</div>
                <p  v-if="!memberBenefits.couponsQuantity"><ab-svg name="my-heng"></ab-svg></p>
                <p style="font-family: DIN_Condensed_Bold" v-else>{{memberBenefits.couponsQuantity? memberBenefits.couponsQuantity * memberBenefits.couponsAmount: "0"}}</p>
            </div>
          </li>
          <li>
            <i><ab-svg name="my-guwen"></ab-svg></i>
            <div>
              <div>企业顾问</div>
              <p>
                <ab-svg :name="memberBenefits.businessDoctorMark?'my-gou':'my-heng'"></ab-svg>
                </p>
            </div>
          </li>
          <li>
            <i><ab-svg name="my-pifu"></ab-svg></i>
            <div>
              <div>个性皮肤</div>
                <p>
                    <ab-svg :name="memberBenefits.ideaskinMark?'my-gou':'my-heng'"></ab-svg>
                </p>
            </div>
          </li>
        </ul>

        <div class="center" :style="classMember">{{memberInfo.gradeName?memberInfo.gradeName:'普通用户'}}权益</div>
      </div>
    </div>

    <div class="Inportazio-mony" v-if="advances && bizType.clientImportRole">
      <div class="title clearfix">
        <h2>进口税款额度</h2>
        <p @click="$router.push('my-quota')">额度详情>></p>
      </div>

      <el-row :gutter="20">
        <el-col :span="8">
          <div>
            <div>总额度(CNY)</div>
            <p v-if="topInfoData.currentAmountFront && topInfoData.status == 3">{{$filters.formatMoney(topInfoData.currentAmountFront)}}</p>
            <p v-else>-</p>
          </div>
        </el-col>
        <el-col :span="8">
          <el-row justify="space-between">
            <el-col :span="12">
              <div>
                已用额度(CNY)
                <el-popover
                    placement="top-start"
                    popper-class='form-pop'
                    :width="400"
                    trigger="hover"
                    >
                    <template #reference>
                        <ab-svg name="my-issue" style="cursor: pointer" class="issue"></ab-svg>
                    </template>
                    <template #default>
                        <p>订单经后台审核后额度将实际使用；订单提交未审核为预占用额度，如需释放额度可修改订单垫税情况</p> 
                    </template>
                </el-popover>
              </div>
              <p v-if="(topInfoData.usedAmount || topInfoData.usedAmount === 0) && topInfoData.status == 3">{{$filters.formatMoney(topInfoData.usedAmount)}}</p>
              <p v-if="!topInfoData.usedAmount && topInfoData.usedAmount !== 0">-</p>
            </el-col>
            <el-col :span="12" class="canCredits">
              含预占额度 (CNY)：<span  v-if="(topInfoData.frozenBigDecimal || topInfoData.frozenBigDecimal === 0) && topInfoData.status == 3">{{$filters.formatMoney(topInfoData.frozenBigDecimal)}}</span>
              <span v-else>-</span>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row justify="space-between">
            <el-col :span="12">
              <div>可用额度(CNY)</div>
              <p style="color: #f87243" v-if="topInfoData.freeAmount && topInfoData.status == 3">{{$filters.formatMoney(topInfoData.freeAmount)}}</p>
              <p v-else>-</p>
            </el-col>
            <el-col :span="10" class="improveMoany">
              <span @click="limitDrawer.show = true" v-if="quoatText != '审批中'">
                <img src="@/assets/img/my/my-add.png" alt="" />
                {{quoatText}}
              </span>
              <span v-else>
                <el-button type="primary" link @click="() => {this.$message({
                    type: 'success',
                    message: '审批中···',
                    offset: 380,
                    grouping: true,
                })}">
                  <ab-svg name="shz"></ab-svg>
                  审批中</el-button>
              </span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div class="userList-bottom">
      <el-row>
        <el-col :span="12">
          <h2>基础资料</h2>
          <div class="entry feijie">
            <div class="item" @click="$router.push('/supplier-management-list')">            
              <i><ab-svg name="my-gongying"></ab-svg></i>
              <span>供应商</span>
            </div>
            <div class="item" v-if="$isAuth('customer:base:customer:view')" @click="$router.push('/client-list')">
              <i><ab-svg name="my-kehu"></ab-svg></i>
              <span>客户</span>
            </div>
            <div class="item" @click="$router.push('/my-address')">
              <i><ab-svg name="my-dizhi"></ab-svg></i>
              <span>地址</span>
            </div>
            <div class="item" @click="$router.push('/material-management')">
              <i><ab-svg name="my-wuliao"></ab-svg></i>
              <span>物料管理</span>
            </div>
            <div class="item" @click="checkedWarning">
              <i><ab-svg name="my-cangcu"></ab-svg></i>
              <span>仓储物料</span>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <h2 style="padding-left: 15px">企业管理</h2>
          <div class="entry">
            <el-badge :value="num.signature" :hidden="num.signature == 0">
                <div class="item" @click="$router.push('/my-signature')">
                    <i><ab-svg name="my-qianzhang"></ab-svg></i>
                    <span>我的签章</span>
                </div>
            </el-badge>
            
            <div class="item" @click="$router.push('/my-enterprise')">
              <i><ab-svg name="my-qiye"></ab-svg></i>
              <span>企业信息</span>
            </div>
            <el-badge :value="num.signProtocol" :hidden="num.signProtocol == 0">
                <div class="item" @click="$router.push('/signProtocol-list')"> 
                    <i><ab-svg name="my-qianshu"></ab-svg></i>
                    <span>签署协议</span>
                </div>
            </el-badge>

            
            <div class="item" @click="$router.push('/account-management')">
              <i><ab-svg name="my-zhanghao"></ab-svg></i>
              <span>账号管理</span>
            </div>
            <div class="item" @click="routeumps('my-center')">
              <i><ab-svg name="mycenter"></ab-svg></i>
              <span>个人中心</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 提升额度 -->
    
    <ab-boost-limit :limitDrawer="limitDrawer" @renderlist="renderlist"></ab-boost-limit>

    <!-- 优惠券 -->
    <div class="coupons">
      <el-drawer v-model="drawer1" :with-header="false" @open="couponsOpen" @close="couponsClose" :destroy-on-close='true'>
        <el-tabs
          v-model="activeName"
          class="demo-tabs"
          @tab-click="handleClick"
        >
          <el-tab-pane label="可用优惠券" name="available" v-loading='loads.available'>
            <div  v-infinite-scroll="availableGrow" infinite-scroll-immediate="false" infinite-scroll-distance='200' infinite-scroll-delay='200'>
                <div class="can" v-for="(item,index) in availableList" :key="index" >
                    <div class="can-left">
                        <div>{{item.typeDesc}}</div>
                        <p>{{item.type == '0'? item.amount : (Number(item.amount) * 10).toFixed(1)}}<span>{{item.type == '0'?'元':'折'}}</span></p>
                    </div>
                    <div class="can-center">
                        <div>无门槛 单次使用</div>
                        <div>有抵扣服务 余额不设找赎</div>
                        <p>有效期：{{item.validStartTime.replaceAll('-', '.').split(' ')[0]}}~{{item.validEndTime.replaceAll('-', '.').split(' ')[0]}}</p>
                    </div>
                    <div class="can-right" @click="changeChecked1(item, index)">
                        <div>立即<br />使用</div>
                    </div>
                </div>
            </div>
          </el-tab-pane>
          
          <el-tab-pane label="已使用" name="used" v-loading='loads.availableUsed' >
            <div v-infinite-scroll="used" infinite-scroll-immediate="false" infinite-scroll-distance='200' infinite-scroll-delay='200'>
                <div class="nocan" v-for="(item,index) in usedList" :key="index">
                    <div class="can-left">
                        <div>{{item.typeDesc}}</div>
                        <p>{{item.type == '0'? item.amount : (Number(item.amount) * 10).toFixed(1)}}<span>{{item.type == '0'?'元':'折'}}</span></p>
                    </div>
                    <div class="can-center">
                        <div>无门槛 单次使用</div>
                        <div>有抵扣服务 余额不设找赎</div>
                        <p>有效期：{{item.validStartTime.replaceAll('-', '.').split(' ')[0]}}~{{item.validEndTime.replaceAll('-', '.').split(' ')[0]}}</p>
                    </div>
                    <div class="can-right">
                        <div>已使用</div>
                    </div>
                </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="已失效" name="expired">
            <div v-infinite-scroll="expiredGrow" infinite-scroll-immediate="false" infinite-scroll-distance='200' infinite-scroll-delay='200'>
                <div class="nocan" v-for="(item,index) in expiredList" :key="index">
                    <div class="can-left">
                        <div>{{item.typeDesc}}</div>
                        <p>{{item.type == '0'? item.amount : (Number(item.amount) * 10).toFixed(1)}}<span>{{item.type == '0'?'元':'折'}}</span></p>
                    </div>
                    <div class="can-center">
                        <div>无门槛 单次使用</div>
                        <div>有抵扣服务 余额不设找赎</div>
                        <p>有效期：{{item.validStartTime.replaceAll('-', '.').split(' ')[0]}}~{{item.validEndTime.replaceAll('-', '.').split(' ')[0]}}</p>
                    </div>
                    <div class="can-right">
                        <div>已失效</div>
                    </div>
                </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        
        <button aria-label="el.drawer.close" class="el-drawer__close-btn" type="button" style="position: absolute;top: 27px;right: 15px;" @click="drawer1 = false">
            <i class="el-icon el-drawer__close">
                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"></path>
                </svg>
            </i>
        </button>
      </el-drawer>
    </div>

    <!-- 成长值记录 -->
    <div class="integral">
      <el-drawer v-model="drawer3" :with-header="true" @open="openIntegral">
        <template #header>
            <h4>成长值记录</h4>
        </template>
        <div class="header">
            <h5>
                当前成长值
                <el-popover
                    placement="right"
                    :width="350"
                    popper-class='form-pop'
                    trigger="hover"
                >
                    <template #reference>
                        <ab-svg name="my-issue"></ab-svg>
                    </template>
                     <template #default>
                        <p>青铜/白银/黄金/铂金/钻石会员，若在有效期90天内没有升级，将会计算会员等级有效期结束之日前180天累计的总成长值，重新评定用户的会员等级，所以该成长值不一定等于历史成长值之和。</p> 
                    </template>
                </el-popover>
            </h5>
            <div>{{ memberInfo.growthValue || 0 }}</div>
        </div>

        <div class="banner" v-infinite-scroll="load" infinite-scroll-immediate="false" infinite-scroll-distance='200' infinite-scroll-delay='200'>
          <div
            class="banner-detail"
            v-for="(item, index) in integralList"
            :key="index"
          >
            <div class="left">
              <div>{{item.action}}</div>
              <p>{{ item.createTime }}</p>
            </div>
            <div class="right">
              <div>{{ item.sourceClientBillNumber }}</div>
              <p>+{{ item.growthValue }}</p>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
    <!-- 升级攻略 -->
    <el-drawer v-model="upgradeDrawer"  custom-class='upgradeDrawer'>
        <template #header>
            <h4>升级攻略</h4>
        </template>
        <template #default>
           <div class="upgradeDrawerBanner" v-if="memberList[0]">
                <h5>会员等级</h5>
                <P><i class="color" style="background-color: #F38746"></i>{{memberList[0].gradeName}}（{{memberList[0].gradeNickname}})：<span>0</span> &lt; 成长值 ≤ <span>{{memberList[1].standardValue}}</span></P>
                <P><i class="color" style="background-color: #8EA3BE"></i>{{memberList[1].gradeName}}（{{memberList[1].gradeNickname}})：<span>{{memberList[1].standardValue}}</span> &lt; 成长值 ≤ <span>{{memberList[2].standardValue}}</span></P>
                <P><i class="color" style="background-color: #F9A038"></i>{{memberList[2].gradeName}}（{{memberList[2].gradeNickname}})：<span>{{memberList[2].standardValue}}</span> &lt; 成长值 ≤ <span>{{memberList[3].standardValue}}</span></P>
                <P><i class="color" style="background-color: #6891C7"></i>{{memberList[3].gradeName}}（{{memberList[3].gradeNickname}})：<span>{{memberList[3].standardValue}}</span> &lt; 成长值 ≤ <span>{{memberList[4].standardValue}}</span></P>
                <P><i class="color" style="background-color: #4385D9"></i>{{memberList[4].gradeName}}（{{memberList[4].gradeNickname}})：成长值 &gt; <span>500000</span></P>
                <div class="remork">备注：成长值与进出口业务下单货值是1:1关系，不足1美元不计算数，例如下单货值为50万，则成长值为50万。</div>
           </div>
           <el-divider style=" border-top: 1px solid #F0F2F5;margin:30px 0"/>
           <div class="upgradeDrawerTime">
                <h5>会员等级有效期与保级条件</h5>
                <P><i class="color" style="background-color: #BDBDBD"></i> 
                    <span v-for="(item,index) in memberList" :key="index">{{item.gradeName ? item.gradeName.substr(0, 2) : ''}}
                        <span v-if="index < memberList.length - 1">/</span>
                    </span>会员有效期为{{effectiveDate}}天，开始时间从晋级等级时间算起，在有效期内若是升级成长值在原基础上叠加，最多升级到钻石会员。</P>
                <P><i class="color" style="background-color: #BDBDBD"></i> 
                    <span v-for="(item,index) in memberList" :key="index">{{item.gradeName ? item.gradeName.substr(0, 2) : ''}}
                        <span v-if="index < memberList.length - 1">/</span>
                    </span>会员，若在有效期{{effectiveDate}}天内没有升级，在会员等级有效期结束之日后会计算用户会员等级结束之日前的{{resetCumulativeDate}}天的累计总成长值评定用户的会员等级。
                </P>
                <div class="remork">例如：青铜/白银/黄金/铂金/钻石会员，有效期为90天，开始时间从晋级时间算起，在有效期内若是升级成长值在原来基础上叠加，最多升级到钻石会员。
                若在有效期90天内没有升级，在会员等级有效期结束之日后会计算用户会员等级结束之日前的180天的累计总成长值评定用户的会员等级。用户张三2020年9月1日从铂金会员变为黄金会员，会员等级有效期为2020年9月1日-2020年11月30日，此时成长值为20万，该成长值是张三2020年2月29日-2020年8月30日，180天内累计所得的成长值。</div>
           </div>
        </template>
    </el-drawer>
    <!-- 余额记录 -->
    <el-drawer v-model="balanceDrawer" :with-header="true" @open="openBalance" custom-class='balance'>
        <template #header>
            <h4>余额明细</h4>
        </template>
        <div class="header">
            <h5>余额（元）</h5>
            <div>{{$filters.formatMoney(nowMoney || 0)}}</div>
        </div>

        <div class="banner" v-infinite-scroll="balancAdd" infinite-scroll-immediate="false" infinite-scroll-distance='200' infinite-scroll-delay='200'>
          <div
            class="banner-detail"
            v-for="(item, index) in balanceList"
            :key="index"
          >
            <div class="top">
              <div>{{item.sourceBillNumber || ''}} {{item.description == '积分兑换'? item.money*10 + '积分兑换' + item.money + '元': item.description}}</div>
              
            </div>
            <div class="bottom">
                <div>{{ item.createTime }}</div>
                <p v-if="item.money > 0" class="green">+{{ $filters.formatMoney(item.money) || 0}} </p>
                <p v-else class="red">{{ $filters.formatMoney(item.money) || 0}}</p>
            </div>
          </div>
        </div>
    </el-drawer>

    <el-dialog v-model="importAndExport" title="请选择业务类型" v-if="true">
        <el-radio-group v-model="importAndExportDetail" class="ml-4">
            <el-radio label="1">进口</el-radio>
            <el-radio label="2">出口</el-radio>
        </el-radio-group>
        
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="importAndExport = false">取消</el-button>
                <el-button type="primary">确定</el-button>
            </span>
        </template>
    </el-dialog>
    <textarea class="copy-text" id="copyText"></textarea>
  </div>
</template>

<script>
// 引入echarts
import * as echarts from "echarts";

export default {
  name: 'my-list',
  data() {
    return {
        loads:{
            show:false,
            available:false,
            availableUsed:false,
        },
        outerOrgId: '', //委托方id
        advances: false, //企业垫税资质
        memberInfo:{},//会员信息
        memberList: [],
        memberBenefitss: [],
        coupon:'',//优惠券
        nowMoney:'',//账户余额
        number:'',//入仓号
        userInfo: this.$utils.getSessionStorage("userInfo"),//用户Id
        drawer1: false,
        limitDrawer: {
            show: false
        },
        drawer3: false,
        activeName: "available", //优惠券当前激活页面
        process: 1, //当前激活流程
        dataFrom: {}, //提额输入值
        //积分记录
        integralList: [],
        //积分记录页码
        pages: {
            currentPage: 1,
            pageSize: 10,
            total:0
        },
        //优惠券页码
        couponTablePages: {
            currentPage: 1,
            pageSize: 10,
            total:0
        },
        //优惠券记录
        availableList:[],
        //余额
        balanceDrawer: false,
        balanceList: [],
        balancePages: {
            currentPage: 1,
            pageSize: 10,
            total:0
        },
        usedList:[],
        expiredList:[],
        topInfoData: {},
        yuan:{
            series: [
            {
              type: "gauge",
              startAngle: 180,
              radius: "200%",
              center: ["50%", "100%"],
              endAngle: 0,
              min: 0,
              max: 0,
              splitNumber: 50,
              itemStyle: {
                color: "#fff",
              },
              progress: {
                show: true,
                roundCap: true,
                width: 10,
                color: "#000",
              },
              pointer: {
                show: false,
              },
              axisLine: {
                roundCap: true,
                lineStyle: {
                  width: 10,
                  color: [[1, "#D4DAE0"]],
                },
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              title: {
                show: false,
              },
              data: [
                {
                //   value: this.getNumer(300000),
                  value: 0,
                },
              ],
            },
          ],
        },
        //选择券类型
        importAndExport: false,
        importAndExportDetail:'',
        //升级攻略
        upgradeDrawer: false,
        effectiveDate: '',//会员有效期
        resetCumulativeDate: '',
        //签章数量
        num: {
            signature: 0,
            signProtocol: 0
        }
    };
  },
   computed: {
    quoatText() {
        let text = ''
        if(!this.topInfoData.currentAmountFront) {
            text = '申请额度'
        }else if(this.topInfoData.status == 1 || this.topInfoData.status == 2 || this.topInfoData.wkStatus == 1) {
            text = '审批中'
        }else {
            text = '提额'
        }
        return text
    },
    requiredAmount() {        
        let a=this.memberList[this.memberInfo.companyGrade] || {}        
        let amount= a.standardValue -this.memberInfo.growthValue || 0
        return amount < 0 ? "再次下单后,重新评定会员等级" : amount;
    },
    //会员颜色
    classMember(){
        let val=this.memberInfo.gradeName
        let cls=''
        switch (val) {
            case "青铜会员":
                cls = "background-color:#f38746";
            break;
            case "白银会员":
                cls = "background-color:#8ea3be";
            break;
            case "黄金会员":
                cls = "background-color:#f9a038";
            break;
            case "铂金会员":
                cls = "background-color:#6891c7";
            break;
            case "钻石会员":
                cls = "background-color:#4385d9";
            break;
        }
        if(!val){
            cls="background-color: #BDBDBD;color: #fff"
        }
        return cls;
    },
    //会员权益
    memberBenefits(){
        let val=this.memberInfo.companyGrade 
        if(val){
            return this.memberBenefitss[val-1] || {}
        }else{
            return {
                integralMagnigication:'1',
                ideaskinMark:'',
                businessDoctorMark:'',
                couponsQuantity:''
            }
        }
    },
    bizType() {
      return this.$utils.getSessionStorage('bizType')
    },
  },
  watch:{
    yuan:{
        handler:function(){
            this.$nextTick(()=>{
                const myChart = echarts.init(document.getElementById("main"));
                myChart.setOption(this.yuan)
            })
            
        },
        deep:true
    }
  },
  methods: {
    //企业垫税资质
    taxAdvances(){
        this.$get('/crm/clientRegisterStep/getIsTaxesFunction').then(({data}) => {
            if(data.code === 'C0000') {
                if(data.result){
                    this.advances = data.result == 1? true : false
                }  
            }
        })
    },
    //余额记录表
    getBalanceList(){
        let params = {
            data: {
                principalId: this.userInfo.outerOrgId || '',
            },
            pageNum: this.balancePages.currentPage,
            pageSize: this.balancePages.pageSize ,
        };
        this.$post('/oms/balanceMoney/list', params).then(({data}) => {
            if(data.code === 'C0000') {
                this.balanceList = this.balanceList.concat(data.result.list) 
                this.balancePages.total = data.result.total
            }
        })
    },
    //余额无限滚动
    balancAdd(){
        if(this.balancePages.currentPage * this.balancePages.pageSize < this.balancePages.total){
            this.balancePages.currentPage++
            this.getBalanceList()
        }     
    },
    openBalance(){
        this.balanceList = []
        this.balancePages.currentPage = 1
        this.getBalanceList()
    },
    progressBar() {
      const myChart = echarts.init(document.getElementById("main"));
      myChart.setOption({
        series: [
          {
            type: "gauge",
            startAngle: 180,
            radius: "200%",
            center: ["50%", "100%"],
            endAngle: 0,
            min: -20000,
            max: 520000,
            splitNumber: 12,
            itemStyle: {
              color: "#fff",
            },
            progress: {
              show: true,
              roundCap: true,
              width: 10,
              color: "#000",
            },
            pointer: {
              show: false,
            },
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 10,
                color: [[1, "#D4DAE0"]],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            title: {
              show: false,
            },
            data: [
              {
                value: this.value,
              },
            ],
          },
        ],
      });
    },

    getNumer(vv) {
      let v = Number(vv || 0)
      let num = 0
      let arr = this.memberList.map((item)=>{
          return Number(item.standardValue)
      })
      let a = 0
      for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if(v>=element) {
              a = index
          }
      }
      if(a == this.memberList.length - 1) {
        this.yuan.series[0].data[0].value = v
        return
      }
      num = this.yuan.series[0].max * (a * 0.23) + ((v - arr[a]) / (arr[a + 1] - arr[a])) / 4.4344 * this.yuan.series[0].max
      this.yuan.series[0].data[0].value = num + this.yuan.series[0].max * 0.04
    },
    routeumps(val) {
      console.log(val);
      this.$router.push({
        path: `/${val}`,
      });
    },
    getClientCreditAmount () {
      this.$get('/bas/client/ClientCreditAmount/get').then(({data}) => {
        if(data.code === 'C0000') {
          if(data.result) {
            if(data.result.amountEntryVos && data.result.amountEntryVos.length) {
              this.topInfoData = data.result.amountEntryVos[0]
            }
            this.topInfoData.frozenBigDecimal = data.result.frozenBigDecimal
            this.topInfoData.status = data.result.status
            this.topInfoData.wkStatus = data.result.wkStatus
          }
        }
      })
    },
    //账号信息
    getMemberInfo(id) {
        this.loads.show=true
        this.$get(`/bas/vipGrade/get`, { id }).then(({ data }) => {
            if (data && data.code === "C0000") {
                if (data && data.result) {
                    this.memberList =data.result.list && data.result.list.length? data.result.list : [];
                    if (this.memberList[this.memberList.length - 1]) {
                      this.yuan.series[0].max = Number(this.memberList[this.memberList.length - 1].standardValue)
                      this.yuan.series[0].max = this.$calc.mul(this.yuan.series[0].max, 1.08)
                    }
                    this.effectiveDate = data.result.effectiveDate
                    this.resetCumulativeDate = data.result.resetCumulativeDate
                    this.$get(`/bas/client/vipInfo/getPrincipalGradeInfo`).then(({ data }) => {
                        if (data && data.code === "C0000") {
                            if (data && data.result) {
                                this.memberInfo = data.result || [];
                                this.memberInfo.companyGrade =this.memberInfo.companyGrade || 0;
                                if(data.result.growthValue ){
                                    this.getNumer(data.result.growthValue)
                                }else{
                                    this.yuan.series[0].data[0].value = 25000
                                }

                                // this.yuan.series[0].data[0].value = 475000
                                // this.getNumer(500000)                                       
                                this.loads.show=false                               
                            }
                        }
                    }
                    );
                }
            }
        });
        this.$get(`/bas/gradePrivilege/get`, { id }).then(({ data }) => {
            if (data && data.code === "C0000") {
                if (data && data.result) {
                    this.memberBenefitss = data.result.list && data.result.list.length? data.result.list: [];
                }
            }
        });
    },
    renderlist () {
      this.getClientCreditAmount()
    },
    // 复制
    copyNumber() {
        const input = document.getElementById('copyText')  // 找到虚拟的输入框
        input.value ='錦盛（香港）有限公司\n' +
        'Future Promising Company Limited\n' +
        '地址：香港沙田安平街 8 号偉達中心 8 楼 801 室\n' +
        'Units 801, Grandtech Centre, No.8 OnPing Street, Siu Lek Yuen, Shatin, NewTerritories, Hong Kong\n' +
        '邮箱：luo.zhanwei@cicsc.com\n' +
        '联系人：羅占偉\n' +
        '電話：00852-26089369\n' +
        '传真：00852-26089331\n' +
        '入仓号：' +  this.number  // 修改文本框的内容
        input.select() // 选中文本
        document.execCommand('copy') // 执行浏览器复制命令
        this.$message({
            type: 'success',
            message: '复制成功',
            offset: 380,
            grouping: true,
        })
    },
    //获取优惠券张数
    getCouponTotal(){
        this.$post('/oms/client/couponEntry/listCount', {data: {queryCouponCode: true}}).then(({data}) => {
          if(data.code === 'C0000') {
            if(data.result) {
              this.coupon = data.result
            }
          }
        })
    },
    //账户余额
    getpointsInformation() {
        this.$get("/oms/principalIntegral/get").then(({data})=>{
            if(data.result) {
            // this.balanceIntegral = data.result.companyIntegral
            this.nowMoney = data.result.nowMoney
            }
        })
    },
    //入仓号
    getQuickEntryData(init) {
      this.$http({url: this.$adornUrl("/bas/client/basCustomer/getClientWorkBench"), method: "post"}).then(({ data }) => {
        if (data.code === "C0000") {
          if(data.result) {
            this.number = data.result.principal.number
            /* this.signStatus = data.result.principal.signStatus
            this.approveStatusDesc = data.result.principal.approveStatusDesc
            this.companyName = data.result.principal.name
            this.date = data.result.principal.earliestSignDate
            this.form = data.result.principalExtend
            this.form.isSameUnit = !!this.form.isSameUnit
            this.form.billBankId = null
            this.isEdit = !this.form.isBillConfirm
            if(init && !this.form.isBillConfirm) {
              this.invoiceReminder = true
            } */
          }
        }
      })
    },
    //成长值记录 
    pageSearch() {
        let params = {
            data: {id: this.userInfo.outerOrgId},
            pageNum: this.pages.currentPage,
            pageSize: this.pages.pageSize ,
        };
        this.$post('/bas/gradeGrowthValue/getList', params).then(({data}) => {
            if(data && data.code === 'C0000') {
                this.integralList=this.integralList.concat(data.result.list)
                this.pages.total=data.result.total
            }else{
                this.$message({type: 'error', message: data.message, offset: 380, grouping: true})
            }
        })
    },
    openIntegral(){
        this.pages.currentPage=1
        this.integralList=[]
        this.pageSearch()
    },
    //积分记录数据滚动加载
    load(){
        if(this.pages.currentPage * this.pages.pageSize < this.pages.total){
            this.pages.currentPage++
            this.pageSearch()
        }        
    },
    //优惠券数据
    getCouponList(activeName) {
        let data = {data: {queryCouponCode: true}, pageSize: this.couponTablePages.pageSize, pageNum: this.couponTablePages.currentPage}

        switch (activeName) {
            case 'available':
                this.loads.available=true
                this.$post(`/oms/client/couponEntry/list`, data).then(({data})=>{
                    if(data.code === 'C0000') {
                        if(data.result && data.result.list && data.result.list.length > 0) {
                            this.availableList=this.availableList.concat(data.result.list)
                            this.availableTotal= data.result.total
                        }
                        this.couponTablePages.total = data.result.total
                    }
                }).finally(() => {
                    this.loads.available=false
                })
                break;
            case 'used':
                this.loads.availableUsed=true
                this.$post(`/oms/client/couponEntry/usedList`, data).then(({data})=>{
                    if(data.code === 'C0000') {
                        if(data.result && data.result.list && data.result.list.length > 0) {
                            this.usedList=this.usedList.concat(data.result.list)
                            this.couponTablePages.total= data.result.total
                        }
                    }
                }).finally(() => {
                    this.loads.availableUsed=false
                })
            break;
            case 'expired':
                this.$post(`/oms/client/couponEntry/noWorkList`, data).then(({data})=>{
                    if(data.code === 'C0000') {
                        if(data.result && data.result.list && data.result.list.length > 0) {
                            this.expiredList=this.expiredList.concat(data.result.list)
                            this.couponTablePages.total= data.result.total
                        }
                    }
                })
            break;
        }
    },
    //优惠券切换
    handleClick(val){
        this.couponTablePages={
            currentPage: 1,
            pageSize: 10,
            total:0
        }
        this.availableList=[],
        this.usedList=[],
        this.expiredList=[],
        this.getCouponList(val.props.name)
    },
    //优惠券滚动
    used(){
        if(this.activeName=="used"){
            if(this.couponTablePages.currentPage * this.couponTablePages.pageSize < this.couponTablePages.total){
                this.couponTablePages.currentPage++
                this.getCouponList('used')
            }
        }        
    },
    availableGrow(){
        if(this.activeName=="available"){
            if(this.couponTablePages.currentPage * this.couponTablePages.pageSize < this.couponTablePages.total){
                this.couponTablePages.currentPage++
                this.getCouponList('available')
            }
        }
    },
    expiredGrow(){
        if(this.activeName==" expired"){
            if(this.couponTablePages.currentPage * this.couponTablePages.pageSize < this.couponTablePages.total){
                this.couponTablePages.currentPage++
                this.getCouponList(' expired')
            }
        }
    },

    couponsOpen(){
        this.getCouponList('available')
    },
    couponsClose(){
        this.availableList=[],
        this.usedList=[],
        this.expiredList=[]
        this.activeName = "available"
    },
    //使用优惠券
    changeChecked1(item, index) {
        this.$get(`/oms/client/entrustImport/getRelatePrincipal`).then(res => {
            if (res.data.code === "C0000") {
                this.$router.push({
                    path:'/import-orders-detail',
                    query: {
                        status : 'add',
                        cache : 'false',
                        principalId: res.data.result.id
                    }
                });
            } else {
                this.$message({
                    type: 'success',
                    message: res.data.message,
                    offset: 380,
                    grouping: true,
                })
            }
        })
    },
    //获取签章数量
    getSignature(){
        this.$post("/sys/esignTask/list", {isPage: "false", data: {viewFlag: 0}}).then(( {data} )=>{
            if (data.code === "C0000") {
                this.num.signature = data.extra[0]
            }
        })
         this.$post("/crm/client/signProtocol/list", {data: {}}).then(( {data} )=>{
            if (data.code === "C0000") {
                this.num.signProtocol = data.result.list.length
            }
        })
    },
    checkedWarning () {
      this.$alert('功能暂未开放！','温馨提示')
    }
  },
  activated() {
    // this.progressBar();
    //成长值  this.yuan.series[0].data[0].value=200000
    /* const myChart = echarts.init(document.getElementById("main"));
    myChart.setOption(this.yuan) */
    this.getpointsInformation()
    this.getClientCreditAmount()
    let userInfo = this.$utils.getSessionStorage("userInfo") || {};
    this.outerOrgId = userInfo.outerOrgId
    //获取会员信息
    this.getMemberInfo(userInfo.outerOrgId);
    this.getCouponTotal()
    this.getQuickEntryData()
    this.pageSearch()
    //获取签章数量
    this.getSignature()
    this.taxAdvances()
    //获取余额列表
    this.getBalanceList()
  },
  created(){
    
  }
};
</script>

<style lang='scss'>
.myList {
  padding: 20px;
  color: #000000;
  .userList-big {
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0px 13px 31px -20px #edeaea;
    .userList-top {
      width: 100%;
      height: 245px;
      background-color: #f9f9fb;
      background: url(@/assets/img/my-top.png) no-repeat;
      background-size: 100% 100%;
       
      .left {
        padding: 43px 0 0 25px;
        width: 100%;
        text-align: left;

        img {
          width: 144px;
          height: 124px;
        }
        h2 {
          font-size: 22px;
          font-weight: bold;
        }
        p {
          font-size: 14px;
          margin: 20px 0;
          font-weight: 400;
        }
        li {
          float: left;
          width: 33%;
            cursor: pointer;
          p {
            margin: 10px 0 0 0;
            font-size: 30px;
            font-weight: 500;
            font-family: DIN_Condensed_Bold;
          }
          div {
            font-size: 14px;
            font-weight: 400;
          }
          .icon-svg {
            width: 16px;
            height: 16px;
            margin-left: 8px;
            vertical-align: middle;
            cursor: pointer;
          }
        }
      }
      .right {
        position: relative;
        width: 100%;
        height: 100%;
        .aaa {
          position: relative;
          width: 420px;
          height: 180px;
          margin-left: 25%;
          font-size: 14px;
          font-weight: 400;
          #main {
            width: 100%;
            height: 100%;

            & > div {
              top: 45px;
            }
          }
          .bronze {
            position: absolute;
            top: 187px;
            left: 0px;
          }
          .silver {
            position: absolute;
            top: 86px;
            left: 54px;
          }
          .gold {
            position: absolute;
            top: 22px;
            left: 178px;
            text-align: center;
            i {
              display: block;
              text-align: center;
              margin: 3px 0 3px 21px;
            }
          }

          .Platinum {
            position: absolute;
            top: 86px;
            left: 288px;
            width: 123px;
          }
          .diamond {
            position: absolute;
            top: 187px;
            left: 345px;
            width: 123px;
          }
          .wordValue {
            position: absolute;
            top: 127px;
            left: 0;
            width: 100%;
            height: 38px;
            text-align: center;
            cursor: pointer;
            p {
              font-size: 14px;
            }
            div {
              color: #f87243;
              font-size: 48px;
              font-weight: bold;
              font-family: DIN_Condensed_Bold;
            }
          }
        }

        .title {
          float: right;
          margin: 27px;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
        }
        i {
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #b9c0c9;
        }
      }
    }
    .userList-btm {
      position: relative;
      top: -20px;
      width: 100%;
      height: 120px;
      padding: 20px 220px 0;
      display: flex;
      align-items: center;
      border-radius: 16px;
      background-color: #fff;
      ul {
        width: 100%;
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          float: left;
          width: 25%;
          i {
            display: block;
            width: 64px;
            height: 64px;
            line-height: 64px;
            border-radius: 50%;
            background: #f2f7ff;
            text-align: center;
            .icon-svg {
              width: 36px;
              height: 36px;
              vertical-align: middle;
            }
          }
          & > div {
            text-align: left;
            margin-left: 10px;
            font-size: 14px;
            font-weight: 400;
          }
          p {
            font-size: 24px;
            color: #0ab2a8;
            margin-top: 7px;
            font-weight: 500;
            .icon-svg {
              width: 18px;
              height: 18px;
              //   vertical-align: top;
            }
          }
        }
      }

      .center {
        position: absolute;
        top: 0;
        left: 0;
        width: 120px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        border-radius: 16px 0;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }

  .Inportazio-mony {
    text-align: left;
    margin-top: 40px;
    .title {
      margin-bottom: 40px;
      font-weight: 400;
      h2 {
        float: left;
        font-size: 18px;
        line-height: 19px;
      }
      p {
        float: right;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .el-row {
      .el-col.el-col-8.is-guttered {
        & > div {
          padding: 35px 35px 35px 30px;
          border-radius: 16px;
          background-color: #f2f7ff;
          height: 139px;
          font-size: 14px;
          font-weight: 400;
          p {
            font-size: 30px;
            margin-top: 10px;
            font-weight: 500;
            font-family: DIN_Condensed_Bold;
          }
          .canCredits {
            padding-top: 45px;
            font-size: 14px;
            text-align: right;
            white-space: nowrap;
            span {
              font-weight: 700;
            }
          }
          .improveMoany {
            line-height: 69px;
            color: #0f7eff;
            text-align: right;
            span {
              cursor: pointer;
              img {
                width: 24px;
                height: 24px;
                vertical-align: middle;
              }
            }
            .icon-svg {
              width: 16px;
              height: 16px;
              margin-right: 5px;
            }
          }

          .issue {
            width: 16px;
            height: 16px;
            vertical-align: middle;
            margin-left: 5px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .userList-bottom {
    margin-top: 40px;
    text-align: left;
    padding-bottom: 95px;
    h2 {
      margin-bottom: 40px;
      font-size: 18px;
      font-weight: 400;
      line-height: 19px;
    }
    .entry {
      display: flex;
      justify-content: space-around;
      margin-top: 40px;
      .item {
        text-align: center;
        cursor: pointer;
        i {
          display: block;
          width: 64px;
          height: 64px;
          line-height: 64px;
          border-radius: 8px;
          background: #f2f7ff;
          .icon-svg {
            width: 36px;
            height: 36px;
            vertical-align: middle;
          }
        }
        span {
          display: block;
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
    .feijie {
      border-right: 1px solid #d2d2d2;
    }
  }
  //弹出框的20px内边距
  .el-drawer.rtl.open {
    border-radius: 16px;
    padding: 0 20px;
  }

  //弹出框 提额
  .Money {
    text-align: left;
    color: #000;
    .el-drawer.rtl.open {
      header {
        font-size: 18px;
        color: #000;
        margin-bottom: 20px;
      }
      .progress {
        position: relative;
        display: flex;
        justify-content: space-between;
        padding-bottom: 40px;
        // color: #0a7cff;
        text-align: center;
        .progress-detail {
          position: relative;
          z-index: 1000;
          width: 64px;
          height: 64px;
          background-color: #f2f7ff;
          border-radius: 8px;
          padding: 14px;
          margin-bottom: 10px;
          div {
            width: 36px;
            height: 36px;
            border-radius: 50%;

            // border: 3px solid #0a7cff;
            border: 3px solid #000;
            text-align: center;
            line-height: 30px;
            font-weight: 700;
          }
        }
        p {
          font-size: 14px;
        }
        i {
          position: absolute;
          top: 32px;
          width: 100%;
          height: 2px;
          border-top: 2px dashed #d6d6d6;
        }
      }
      .el-drawer__footer {
        text-align: center;
      }

      .sureMoney {
        .el-textarea {
          .el-textarea__inner {
            min-height: 43px !important;
            padding-top: 10px;
            color: #000;
            line-height: 23px;
            /*  &::placeholder {
              color: #000;
            } */
          }
        }
        .issue {
          .el-form-item__label {
            .icon-svg {
              width: 14px;
              height: 14px;
              margin-left: 4px;
              vertical-align: middle;
              cursor: pointer;
            }
          }
        }
      }
      //当前流程高亮
      .sure {
        color: #0a7cff;
        .progress-detail {
          div {
            border: 3px solid #0a7cff;
          }
        }
      }
    }
  }

  //优惠券
  .coupons {
    /*去掉切换时el-tab-pane底部的蓝色下划线*/
    .el-tabs__active-bar {
      background-color: transparent !important;
    }
    /*去掉tabs底部的下划线*/
    .el-tabs__nav-wrap::after {
      position: static !important;
      
    }
    .el-tabs__nav-scroll{
        margin-bottom: 15px;
        .el-tabs__item{
            height: 45px;
        }
      }
    .el-tabs__item.is-top {
      padding: 0;
      margin-right: 40px;
      font-size: 16px;
      &.is-active {
        background-image: url(@/assets/img/nav-active.png);
        background-repeat: no-repeat;
        background-position: bottom;
        border-bottom: none;
        font-size: 18px;
      }
    }
    .el-drawer.rtl.open{
        width: 31% !important;
        .el-drawer__body{
            position: relative;
        }
    }
    .demo-tabs {
      .can,
      .nocan {
        display: flex;
        align-content: center;
        align-items: center;
        width: 100%;
        height: 100px;
        text-align: left;
        padding: 0 4.2%;
        margin-bottom: 30px;
        .can-left {
          width: 43%;
          display: flex;
          height: 85%;
          div {
            width: 16px;
            font-size: 16px;
            padding-top: 8px;
          }
          p {
            width: 100%;
            margin-left: 14%;
            font-size: 48px;
            font-weight: 500;
            line-height: 79px;
            font-family: DIN_Condensed_Bold;
            span {
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
        .can-center {
          width: 42%;
          text-align: center;
          color: #fff;
          font-size: 12px;
          font-weight: 400;
          p {
            margin-top: 10px;
          }
        }
        .can-right {
          width: 17%;
          color: #fff;
          padding-left: 3.5%;
          div {
            width: 66px;
            height: 66px;
            padding-top: 11px;
            border: 5px solid #ffffff;
            border-radius: 50%;
            text-align: center;
            font-size: 12px;
            font-weight: 400;

            cursor: pointer;
          }
        }
      }
      .can {
        background: url(@/assets/img/my/can.png);
        background-size: 100% 100%;
        .can-left {
          div {
            color: #f87243;
          }
          p {
            color: #f87243;
          }
        }
      }
      .nocan {
        background: url(@/assets/img/my/nocan.png);
        background-size: 100% 100%;
        .can-left {
          div {
            color: #959595;
          }
          p {
            color: #959595;
          }
        }
        .can-right {
          div {
            padding-top: 16px;
            cursor: not-allowed;
          }
        }
      }
    }
  }

  //积分成长值
  .integral {
    text-align: left;
    color: #000;
    font-size: 16px;
    font-weight: 400;
    //滚动条的宽度
    ::-webkit-scrollbar {
        width: 8px;        
    }
    //滚动条的滑块
    ::-webkit-scrollbar-thumb {
        background-color: #aaa;
        border-radius: 3px;
        &:hover {
            background: #999;
        }
    }
    .icon-svg {
      width: 19px;
      height: 19px;
      vertical-align: middle;
      cursor: pointer;
    }

    .el-drawer.rtl.open {
      header {
        color: #000;
        margin-bottom: 20px;
        h4 {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }
    .header {
      h5 {
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        .icon-svg {
          width: 14px;
          height: 14px;
          margin-left: 5px;
        }
      }
      div {
        font-size: 48px;
        font-weight: 500;
        color: #0a7cff;
        font-family: DIN_Condensed_Bold
      }
    }
    .banner {
      margin-top: 40px;
      .banner-detail {
        display: flex;
        justify-content: space-between;
        padding: 20px 0;
        border-bottom: 1px solid #f0f2f5;
        .left {
          div {
            font-size: 18px;
            margin-bottom: 10px;
          }
          p {
            font-size: 14px;
            color: #757575;
            font-weight: 400;
          }
        }
        .right {
          text-align: right;
          div {
            font-size: 14px;
            color: #757575;
            margin-bottom: 10px;
            font-weight: 400;
          }
          p {
            font-size: 24px;
            font-weight: 500;
            color: #0ab2a8;
            font-family: DIN_Condensed_Bold
          }
        }
        &:first-child {
          border-top: 1px solid #f0f2f5;
        }
      }
    }
  }

    //余额记录
    .balance{
        text-align: left;
        color: #000;
        font-size: 16px;
        font-weight: 400;
        //滚动条的宽度
        ::-webkit-scrollbar {
            width: 8px;        
        }
        //滚动条的滑块
        ::-webkit-scrollbar-thumb {
            background-color: #aaa;
            border-radius: 3px;
            &:hover {
                background: #999;
            }
        }
        .icon-svg {
            width: 19px;
            height: 19px;
            vertical-align: middle;
            cursor: pointer;
        }

        .el-drawer.rtl.open {
            header {
                color: #000;
                margin-bottom: 20px;
                h4 {
                font-size: 18px;
                font-weight: 400;
                }
            }
        }
        .header {
            h5 {
                margin-bottom: 10px;
                font-size: 14px;
                font-weight: 400;
                .icon-svg {
                width: 14px;
                height: 14px;
                margin-left: 5px;
                }
            }
            div {
                font-size: 48px;
                font-weight: 500;
                color: #0a7cff;
                font-family: DIN_Condensed_Bold
            }
        }
        .banner {
            margin-top: 40px;
            .banner-detail {
                padding: 15px 0;
                border-bottom: 1px solid #f0f2f5;
                .top {
                    div {
                        font-size: 18px;
                        margin-bottom: 10px;
                    }
                    p {
                        font-size: 14px;
                        color: #757575;
                        font-weight: 400;
                    }
                }
                .bottom {
                    display: flex;
                    justify-content: space-between;
                    div {
                        font-size: 14px;
                        color: #757575;
                        margin-bottom: 10px;
                        font-weight: 400;
                    }
                    p {
                        font-size: 24px;
                        font-weight: 500;
                        font-family: DIN_Condensed_Bold
                    }
                    .green {
                        color: #0ab2a8;
                    }
                    .red {
                        color: #ff0000;
                    }
                }
                &:first-child {
                border-top: 1px solid #f0f2f5;
                }
            }
        }
    }
  
    //升级攻略
    .upgradeDrawer{
        padding: 0 !important;
        header{
            padding: 20px 40px 0 40px;
        }
        .el-drawer__body{
            padding: 20px 40px;
        }
        //滚动条的宽度
        ::-webkit-scrollbar {
            width: 8px;        
        }
        //滚动条的滑块
        ::-webkit-scrollbar-thumb {
            background-color: #aaa;
            border-radius: 3px;
            &:hover {
                background: #999;
            }
        }
        .el-drawer__header{
            margin-bottom: 20px;
        }
        .upgradeDrawerBanner{
            h5{
                font-size: 16px;
                margin-bottom: 30px;
            }
            p{
                margin-bottom: 20px;
                .color{
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    margin-right: 14px;
                }
                span{
                    font-size: 16px;
                }
            }
            .remork{
                padding: 10px 16px;
                font-size: 14px;
                color: #F87243;
                background-color: #FEEAE3;
                line-height: 27px;
                border-radius: 8px;
                margin-top: 30px;
            }
        }
        .upgradeDrawerTime{
            h5{
                font-size: 16px;
                margin-bottom: 30px;
            }
            p{
                line-height: 37px;
                padding-left: 20px;
                .color{
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    margin-right: 14px;
                    margin-left: -20px;
                }
            }
            .remork{
                padding: 10px 16px;
                font-size: 14px;
                color: #F87243;
                background-color: #FEEAE3;
                line-height: 27px;
                border-radius: 8px;
                margin-top: 20px;
                line-height: 30px;
            }
        }
    }
}
</style>